import { SVGProps } from "react";

const TickCircleSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5013 1.66669C5.90964 1.66669 2.16797 5.40835 2.16797 10C2.16797 14.5917 5.90964 18.3334 10.5013 18.3334C15.093 18.3334 18.8346 14.5917 18.8346 10C18.8346 5.40835 15.093 1.66669 10.5013 1.66669ZM14.4846 8.08335L9.75964 12.8084C9.64297 12.925 9.48464 12.9917 9.31797 12.9917C9.1513 12.9917 8.99297 12.925 8.8763 12.8084L6.51797 10.45C6.2763 10.2084 6.2763 9.80835 6.51797 9.56669C6.75964 9.32502 7.15964 9.32502 7.4013 9.56669L9.31797 11.4834L13.6013 7.20002C13.843 6.95835 14.243 6.95835 14.4846 7.20002C14.7263 7.44169 14.7263 7.83335 14.4846 8.08335Z"
      fill="currentColor"
    />
  </svg>
);
export default TickCircleSolid;
